import { getReportingListInitialTab } from '@app/utils/reportingTab';
import React, { ReactElement } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import MemberReporting from './memberReporting';
import MembersReportingList from './membersReportingList';

const MembersReportingRouter = (): ReactElement => {
  const { search } = useLocation();
  // The member page's own tab, seeded from the URL so a shared link lands on the tab it names.
  const [activeTab, setActiveTab] = React.useState(() => getReportingListInitialTab(search, undefined));

  return (
    <Routes>
      <Route path=":memberId" element={<MemberReporting activeTab={activeTab} setActiveTab={setActiveTab} />} />
      <Route path="*" element={<MembersReportingList />} />
    </Routes>
  );
};

export default MembersReportingRouter;
